var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#C13D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#D6B5B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.102 31.871c1.476 0 2.433-.926 2.433-2.355v-.7h-2.312v.707h1.449v.125c-.008.868-.637 1.45-1.559 1.45-1.058 0-1.722-.836-1.722-2.184v-.008c0-1.328.66-2.172 1.703-2.172.773 0 1.312.375 1.515 1.043l.012.04h.875l-.008-.04c-.203-1.09-1.113-1.816-2.394-1.816-1.578 0-2.598 1.16-2.598 2.95v.007c0 1.813 1.008 2.953 2.606 2.953zm3.64-.137h.875v-5.636h-.875v5.636zm2.29 0h.874v-2.359h2.422v-.738h-2.422v-1.785h2.645v-.754h-3.52v5.636z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.9a29fbb514bd2748015d4a4b65793916.svg";
export { ForwardRef as ReactComponent };